import {getDocumentName} from '../../../utils/document';
import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_INTERNAL_LINK, CONTENT_TYPE_TEXT, CONTENT_CATEGORY_MODEL} from '../../constants';

const DOCUMENT_PATH = `${pathHelpContentFile}it/IT_MOD_NON_CIBTP/${getDocumentName('Non affiliation caisse de congés payés ok')}.docx`;

export default {
  id: 'MOD_NON_CIBTP',
  title: 'Un modello di Non affiliazione alla cassa di ferie pagate?',
  description: '',
  categories: [CONTENT_CATEGORY_MODEL],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Se non siete iscritti ad una cassa di ferie pagate, prendete il seguente modello:'
  },
  {
    type: CONTENT_TYPE_INTERNAL_LINK,
    value: DOCUMENT_PATH,
    label: 'Non affiliazione alla cassa di ferie pagate.'
  }]
};
